export default ({ lastItem, lastProposal }) => {
  if (lastProposal && lastProposal.createdAt > lastItem.createdAt) {
    return lastProposal;
  }

  return lastItem;
};
